import { type supplyChainBookingsQuery } from "../BookingsTable";
import { type supplyChainBookingFieldSettingsQuery } from "./index";
import { type VariablesOf, type ResultOf } from "@/graphql";

export type { BookingStatus } from "./validation";

export type FieldSetting = NonNullable<
  NonNullable<ResultOf<typeof supplyChainBookingFieldSettingsQuery>["supplyChainBookingFieldSettings"]>[number]
>;

export type MetadataField = FieldSetting["field"];

// Form Structure Types
export type SectionId = "lot_inventory" | "dates" | "financial" | "weight" | "source" | "transportation";

// Extract all possible column IDs from the GraphQL schema
type AllColumnIds = NonNullable<NonNullable<VariablesOf<typeof supplyChainBookingsQuery>["sortBy"]>[number]>["field"];

// Define which ones are base columns
export type BaseColumnId = AllColumnIds &
  (
    | "NAME"
    | "PLANNED_SHIPPING_DATE"
    | "CREATED_AT"
    | "ACCOUNT_MANAGER_LAST_NAME"
    | "NUMBER_OF_HEAD"
    | "SOURCE_PARTNER_BUSINESS_NAME"
    | "DESTINATION_PARTNER_BUSINESS_NAME"
    | "STATUS"
  );

export const BASE_COLUMN_IDS: BaseColumnId[] = [
  "NAME",
  "PLANNED_SHIPPING_DATE",
  "CREATED_AT",
  "ACCOUNT_MANAGER_LAST_NAME",
  "NUMBER_OF_HEAD",
  "SOURCE_PARTNER_BUSINESS_NAME",
  "DESTINATION_PARTNER_BUSINESS_NAME",
  "STATUS",
];

export interface FieldDefinition {
  id: MetadataField;
  columnSpan?: 1 | 2 | 3;
  section: SectionId;
}

export interface SectionDefinition {
  id: SectionId;
  title: string;
  fields: readonly FieldDefinition[];
}

export type FormStructure = readonly SectionDefinition[];

// Utility Types for Processing
export interface ProcessedField extends FieldDefinition {
  isRequired: boolean;
  isVisible: boolean;
}

export interface ProcessedSection extends Omit<SectionDefinition, "fields"> {
  fields: ProcessedField[];
}

// Lookup Types
export type FieldLookup = {
  [K in MetadataField]: {
    section: SectionId;
    columnSpan?: 1 | 2 | 3;
  };
};
